import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientContainer = memo(
  (props: PropsWithChildren) => {
    return <View style={styles.container}>{props.children}</View>;
  },
);

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing['2'],
    paddingVertical: theme.spacing['3'],
  },
});
